import { type CreateImproveAnswerDTO } from './types';
import poliApiGatewayRequest from 'src/utils/poliApiGatewayRequest';

export class ImproveAnswerService {
  static async createImprovedAnswer(
    data: CreateImproveAnswerDTO
  ): Promise<any> {
    const url = `/copilot/ai/improve-message`;

    const response = await poliApiGatewayRequest.post<any>(url, data);

    return response.data;
  }
}
